/**
 * RoadFieldLabel Component
 * Displays the field label with loading indicator and status badges
 */

import { Group, Text, Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FONT_WEIGHT_SEMIBOLD } from '@/constants/ui';
import { RoadStatusBadge } from './RoadStatusBadge';
import type { RoadFieldLabelProps } from '../RoadDisplayField.types';
import { ROAD_DISPLAY_FIELD_CONSTANTS } from '../RoadDisplayField.constants';

export function RoadFieldLabel({
  isDetectingGPS,
  isWaitingForInitialGPS,
  value,
  roadSource,
}: RoadFieldLabelProps) {
  const { t } = useTranslation();

  const isLoading = isDetectingGPS || isWaitingForInitialGPS;

  return (
    <Group gap="xs">
      <Text size="sm" fw={FONT_WEIGHT_SEMIBOLD}>
        {t('taskForm.location')}
      </Text>

      {isLoading && (
        <Group gap={4}>
          <Loader size={ROAD_DISPLAY_FIELD_CONSTANTS.ICONS.LOADER_SMALL} />
          <Text size="xs" c="dimmed">
            {t('gps.detecting')}
          </Text>
        </Group>
      )}

      <RoadStatusBadge value={value} roadSource={roadSource} />
    </Group>
  );
}
